module.exports = "<p>\n  following works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/src/app/home/following/following.component.html
// module id = ../../../../../src/app/home/following/following.component.html
// module chunks = common